/**
 * Enum of the modals in the app so we can send them through redux.
 */
export enum IKON_MODAL {
  NONE,
  GUEST_PHOTO,
  GUEST_PRINTER,
  GUEST_RFID,
  GUEST_FNF,
  GUEST_DTW,
  GUEST_ADD_TO_HOTLIST,
  GUEST_REMOVE_FROM_HOTLIST,
  GUEST_COMMENT_HISTORY,
  GUEST_ADD_COMMENT,
  GUEST_VIEW_DAYS,
  GUEST_MEDIA_HISTORY,
  GUEST_WAIVER,
  GUEST_GROUP_PRINT,
  GUEST_PAYMENT_METHOD,
  GUEST_HYDRATION_REPORT,
  HOTLIST_REPORT,
  WEEKLY_VISITOR_REPORTS,
  ACCESS_INDIVIDUAL_EDIT,
  ACCESS_MULTI_CREATE,
  ACCESS_MULTI_EDIT,
}
